const FormService = {
  /**
   * Create a new form
   * @param {String} broadcastId
   * @param {Object} payload
   * @returns {?Object}
   */
  create: async (payload) => {
    const { data } = await ovpFetch('/app/form', {
      method: 'POST',
      body: JSON.stringify(payload),
    });

    return data;
  },
  listAll: async (payload) => {
    const params = Object.keys(payload).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(payload[key])}`).join('&');
    const { data, headers } = await ovpFetch(`/app/form?${params}`);
    const pagination = {
      max_page: 1,
      current_page: payload.page,
    };
    const { link } = headers;

    let total = 0;

    if (link) {
      const linkSplit = link.split(',');
      const lastIndex = linkSplit.findIndex(rel => rel.includes('rel="last"'));
      const prevIndex = linkSplit.findIndex(rel => rel.includes('rel="prev"'));
      if (lastIndex > -1) {
        pagination.max_page = parseInt(linkSplit[lastIndex].match(/(?:&page=|\?page=)(\d+)/)[1], 10);
      } else if (prevIndex > -1) {
        pagination.max_page = parseInt(linkSplit[prevIndex].match(/(?:&page=|\?page=)(\d+)/)[1], 10) + 1;
      }
      pagination.current_page = pagination.max_page < pagination.current_page ? pagination.max_page : pagination.current_page;
    }

    if (headers['total-count']) {
      total = headers['total-count'];
    }

    return {
      forms: data,
      pagination,
      total,
    };
  },
  /**
   * List all forms for broadcast
   * @param {String} broadcastId
   * @returns {Array}
   */
  list: async (broadcastId) => {
    const { data } = await ovpFetch(`/app/form?broadcast_id=${broadcastId}`);
    if (data === null) {
      return [];
    }
    return data;
  },
  /**
   * Get form with specific id
   * @param {String} id
   * @returns {Object}
   */
  get: async (id) => {
    const { data } = await ovpFetch(`/app/form/${id}`);
    return data;
  },
  /**
   * Update a form
   * @param {String} id
   * @param {Object} payload
   * @returns {?Object}
   */
  update: async (id, payload) => {
    const { data } = await ovpFetch(`/app/form/${id}`, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    return data;
  },
  /**
   * Delete a form with id
   * @param {String} id
   * @returns {Boolean}
   */
  delete: async (id) => {
    await ovpFetch(`/app/form/${id}`, {
      method: 'DELETE',
      iLikeItRaw: true,
    });
  },
  /**
   * Promote form
   */
  promote: async (id) => {
    await ovpFetch(`/app/form/${id}/promote`);
  },
  /**
   * Get submissions for form with id
   * @param {String} id
   * @returns {Array}
   */
  getSubmissions: async (id) => {
    const { data } = await ovpFetch(`/app/form/${id}/submissions`);
    return data;
  },
  exportSubmissions: async (id) => {
    const { data } = await ovpFetch(`/app/form/${id}/csv`, {
      iLikeItRaw: true,
    });
    return data;
  },
};

// eslint-disable-next-line
export { FormService }